import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectClassroomInsUpd } from "../../../redux/classroom/classroomInsUpdSlice";
import { retrieveRoutine, routineSlice, selectRoutine } from "../../../redux/routine/routineSlice";
import { useEffect } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { assertImagesUrl, getImageProcessorStyleName, LoadState } from "../../../redux/common";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { selectUser } from "../../../redux/user/userSlice";
import { getClassroomStatusName } from "../../../redux/classroom/classroomSlice";

export function ClassroomInsUpdReview() {
    const dispatch = useAppDispatch();
    const classroomInsUpd = useSelector(selectClassroomInsUpd);
    const routine = useSelector( selectRoutine );
    const classroom = classroomInsUpd.classroom;
    const user = useSelector(selectUser);

    useEffect(() => {
        if(classroom.routineId) {
            dispatch(routineSlice.actions.check(classroom.routineId));
            if (routine.state.state === LoadState.NotStarted && isTokenReady(user)) {
                dispatch(retrieveRoutine({ routineId: classroom.routineId }));
            }
        } else {
            dispatch(routineSlice.actions.clean());
        }
    }, [classroom, routine, user]);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão
        </Typography>
        <Grid container spacing={3}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{classroomInsUpd.classroom.name}</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Ano</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{classroomInsUpd.classroom.year}</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Rotina</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{routine.selected?.name || "Sem rotina"}</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Status</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">
                    { getClassroomStatusName( classroomInsUpd.classroom.classroomStatus ) }
                </Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Imagem</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">
                    { getImageProcessorStyleName( classroomInsUpd.classroom.imageProcessorStyle ) }
                </Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                    <Avatar
                        src={assertImagesUrl(classroomInsUpd.classroom.url)}
                        alt={classroomInsUpd.classroom.name}
                        sx={{ width: 60, height: 60, border: "1px solid #ccc" }}
                    />
                </Box>
            </Grid>
            <Divider flexItem />
        </Grid>
</>;
}